import * as cancerScreeningService from "../../services/cancerScreeningService";

import { Grid, useTheme } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";

import CancerScreeningInfo from "../../components/CancerScreening/CancerScreeningInfo";
import { CancerScreeningResultModel } from "../../models/cancerScreeningResultModel";
import { CefSharpShell } from "../../helpers/CefSharpShell";
import { GetCancerScreeningInfoModel } from "../../models/getCancerScreeningInfoModel";
import { LangContext } from "../../context/LangContext";
import Layout from "../../components/Layout";
import LoadingIndicator from "../../components/LoadingIndicator";
import NewScreeningRequestDetails from "../../components/CancerScreening/NewScreeningRequestDetails";
import Section from "../../components/Section";
import { UserContext } from "../../context/UserContext";
import translations from "../../assets/json/translations.json";
import useNotifier from "../../hooks/useNotifier";

const NewScreeningRequestsDetailPage: React.FC<
  RouteComponentProps<{ id: string }>
> = ({ match }) => {
  const theme = useTheme();
  const [lang] = useContext(LangContext);
  const history = useHistory();
  const shellHelper = new CefSharpShell();

  const [requestLoading, setRequestLoading] = useState(false);
  const [infoLoading, setInfoLoading] = useState(false);
  const [cancerScreeningRequest, setCancerScreeningRequest] =
    useState<CancerScreeningResultModel | null>(null);
  const [cancerScreeningInfo, setCancerScreeningInfo] =
    useState<GetCancerScreeningInfoModel | null>(null);
  const id = match.params.id;

  const { notifySuccess } = useNotifier();
  const [user] = useContext(UserContext);

  useEffect(() => {
    const fetchScreeningRequest = async () => {
      setRequestLoading(true);

      const response = await cancerScreeningService.getCancerScreening(id);
      setRequestLoading(false);

      if (response.isOk) {
        setCancerScreeningRequest(response?.data?.cancerScreening || {});
        fetchScreeningInfo(response.data?.cancerScreening); 
      }
    };

    const fetchScreeningInfo = async (
      data: CancerScreeningResultModel | undefined
    ) => {
      setInfoLoading(true);
      
      const response = await cancerScreeningService.getCancerScreeningInfo({
        userSsn: user?.ssn || "",
        userName: user?.name || "",
        personName: data?.personName || "",
        personSsn: data?.personSsn || "",
      });
      setInfoLoading(false);

      if (response.isOk && response.data) {
        setCancerScreeningInfo(response.data);
      }
    };

    fetchScreeningRequest();
    /* eslint-disable */
  }, [id]);

  return (
    <Layout
      useDefaultSpacing
      title={translations.newScreeningRequest[lang]}
      otherButton={{
        label: translations.newScreeningRequests[lang],
        onClick: () => history.push("/new-screening-requests"),
      }}
    >
      <Section>
        {requestLoading ? (
          <Grid
            container
            justify="center"
            alignItems="center"
            style={{ marginTop: theme.spacing(2) }}
          >
            <LoadingIndicator />
          </Grid>
        ) : (
          <>
            {cancerScreeningRequest && (
              <NewScreeningRequestDetails
                screeningRequest={cancerScreeningRequest}
                cancelCancerScreeningInParent={cancelScreeningAndNotify}
                createAnalysisRequestInParent={createAnalysisRequestAndNotify}
              />
            )}
            
            {infoLoading ? (
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ marginTop: theme.spacing(2) }}
              >
                <LoadingIndicator />
              </Grid>
            ) : (
              <>
                {cancerScreeningInfo?.patientCancerScreeningInfo && (
                  <CancerScreeningInfo
                    patientInfo={cancerScreeningInfo.patientCancerScreeningInfo}
                  />
                )}
              </>
            )}
          </>
        )}
      </Section>
    </Layout>
  );

  async function cancelScreeningAndNotify(id: number, userSsn: string) {
    const response = await cancerScreeningService.cancelCancerScreening(
      id,
      userSsn
    );
    if (response.isOk) {
      notifySuccess(translations.deleteScreeningRequestConfirmed[lang]);
      history.push(`/new-screening-requests`);
    }
  }
  async function createAnalysisRequestAndNotify(
    id: number,
    userSsn: string,
    userName: string,
    originalUserSsn: string,
    analysisType: number
  ) {
    const response = await cancerScreeningService.createAnalysisRequest(
      id,
      userSsn,
      userName,
      originalUserSsn,
      analysisType
    );
    if (response.isOk) {
      if (cancerScreeningRequest) {
        shellHelper.printTemplateLabel(
          cancerScreeningRequest,
          response.data?.specimenId || ""
        );
      }
      notifySuccess(
        translations.createTestAnalysisConfirmed[lang] +
        response.data?.specimenId
      );
      history.push(`/new-screening-requests`);
    }
  }

};

export default NewScreeningRequestsDetailPage;
